# These are the minimum required fields for a stageset on the pipeline list page

fragment StagesetBasic on Stageset {
    id
    name
    htmlUrlPath
    default
    position
    canDelete
    canAccess
    isArchived
    status
    stages {
        id
        name
        position
        description
        defaultConfidence
    }
    leadDistributionAutomation {
        id
    }
    status
    numOfOpenLeads
}
